import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["onUpdate:modelValue", "onInput", "onKeydown", "data-qa"]

import { ref, reactive, onMounted } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'VitaCodeInput',
  emits: ["pinCode"],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit;

const pin = reactive(["", "", "", ""]);
const inputRefs = ref<HTMLInputElement[]>([]);
const isFocused = ref(false);

const onInput = (index: number) => {
  // Разрешаем только цифры
  pin[index] = pin[index].replace(/\D/g, "");

  if (pin[index].length > 0 && index < 3) {
    inputRefs.value[index + 1].focus();
  }
  emit("pinCode", pin.join("").length >= 1 ? pin.join("") : null);
};

// Очистка полей через Backspace
const onBackspace = (index: number) => {
  if (pin[index] === "" && index > 0) {
    inputRefs.value[index - 1]?.focus();
  } else {
    pin[index] = ""; // Очищаем поле даже если оно уже заполнено
  }
};

// Проверка, остался ли хоть один input в фокусе
const checkFocus = () => {
  isFocused.value = inputRefs.value.some((input: HTMLInputElement) => input === document.activeElement);
};

// Установка фокуса на первый input в компоненте
const focusFirstInput = () => inputRefs.value[0]?.focus();

onMounted(() => {
  focusFirstInput();
})

// Отдаём метод для фокуса родительскому компоненту
__expose({ focusFirstInput });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["pin-input-container", { focused: isFocused.value }])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pin, (_, index) => {
      return _withDirectives((_openBlock(), _createElementBlock("input", {
        key: index,
        type: "text",
        class: "pin-input",
        maxlength: "1",
        "onUpdate:modelValue": ($event: any) => ((pin[index]) = $event),
        onInput: ($event: any) => (onInput(index)),
        placeholder: "＿",
        onKeydown: _withKeys(($event: any) => (onBackspace(index)), ["backspace"]),
        onFocus: _cache[0] || (_cache[0] = ($event: any) => (isFocused.value = true)),
        onBlur: checkFocus,
        ref_for: true,
        ref_key: "inputRefs",
        ref: inputRefs,
        inputmode: "numeric",
        "data-qa": `code-input-field-${index + 1}-fill`
      }, null, 40, _hoisted_1)), [
        [_vModelText, pin[index]]
      ])
    }), 128))
  ], 2))
}
}

})